export const APP_NAME = "Consultoría Global";
export const APP_VERSION = "1.0.0";

export const CONTACT_INFO = {
  EMAIL: "contact@consultoriaglobal.com",
  PHONE: "+54-XXX-XXX-XXXX",
} as const;


export const INTRANET_URL =
  process.env.REACT_APP_INTRANET_URL ??
  "https://cg-intranet-fe-prod-1021060328934.us-central1.run.app/";